import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, map } from 'rxjs';
import { UserProfileState } from 'src/app/core/user-profile/store/user-profile.state';
import { User } from '../models/user.model';
import { GetUserAction } from 'src/app/core/user-profile/store/user-profile.actions';

@Injectable({
  providedIn: 'root'
})
export class FirstLoginService {
  @Select(UserProfileState.selectUser) user$!: Observable<User>;
  constructor(private _store:Store) {
    this._store.dispatch([
      GetUserAction,
    ]);
   }

  /**
   * Check if the user has set his site
   * @returns true if the user has set his site, false otherwise
   */
  isSiteSet(): Observable<boolean> {
    return this.user$.pipe(
      map(user => user?.idSite !== null)
    );
  }
}
